import {
  type Card,
  type CardIdentifier,
} from '@/types/productSelectionAndCheckout/types';

export const isCardSelected = (
  selectedItemIds: number[],
  card: Card | CardIdentifier,
) => {
  if (card.fullSizeItemId) {
    return selectedItemIds.includes(card.fullSizeItemId);
  }

  if (card.fullSizeItemIds) {
    return (
      card.fullSizeItemIds.length ===
      card.fullSizeItemIds.filter((fullSizeItemId) =>
        selectedItemIds.includes(fullSizeItemId),
      ).length
    );
  }

  return false;
};
